<style scoped>
  .artworks {
    display: flex;
    flex-wrap: wrap;
  }
  .artwork-item {
    display: -ms-flexbox;
    padding: 10px;
    background: #fff;
    border-bottom: 1px solid #eee;
    max-width: 120px;
  }
  /* .artwork-image {
    height: 100px;
    background: #eee;
  } */
  .artwork-info {
    /* text-align: center; */
    /* margin-top: 10px; */
  }

  .artwork-container{
    height: 77vh;
  }

  .submit-artwork{
    padding: 10px;
    background: #fff;
    border-bottom: 1px solid #eee;
    position: fixed;
    display: block;
    bottom: 63px;
    width: 100%;
    z-index: 99;
  }
  .artworks {
    background: #fff;
    /* justify-content: center; */
  }
  .cover-photo{
    height: 100px;
    width: 100px;
    background: #eee;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    margin-bottom: 10px;
    margin-right: 10px;
  }
  .artwork-info > p{
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .artwork-info > h3{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .single-artwork__image {
    height: 350px;
    width:100%;
    background: #eee;
  }
  .single-artwork__image > img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
  .single-artwork__info {
    margin-top: 5px;
  }
  #artworkUrl{
    display: none;
  }
</style>

<template>
  <AppLayout class="events-component">
    <div class="submit-artwork" v-if="activeTab == 'userPost'">
    <!-- <div class="submit-artwork"> -->
      <Button type="primary" icon="image" long v-on:click="goToArtWork">Submit artwork</Button>
    </div>
    <Row type="flex" justify="center">
      <Col :span="24">
        <div class="artwork-container">
          <Tabs :value="activeTab" @on-click="changeTab">
            <TabPane label="Official" name="official">
              <div class="artworks">
                <div class="artwork-item" v-for="(artwork, indx) in officialArtworks" :key="indx" v-on:click="displayArtwork(artwork)" v-if="!artwork.data.is_user">
                  <div class="artwork-image">
                    <div class="cover-photo" v-if="artwork.cover_photo" :style="{ 'background-image': 'url(' + artwork.cover_photo[0].medium + ')' }">
                    </div>
                  </div>
                  <div class="artwork-info" v-if="artwork.data">
                    <h3>{{artwork.title}}</h3>
                    <p>{{artwork.data.text}}</p>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane label="User Post" name="userPost">
              <div class="artworks">
                <div class="artwork-item" v-for="(artwork, indx) in userArtworks" :key="indx" v-on:click="displayArtwork(artwork)" v-if="artwork.data.is_user">
                  <div class="artwork-image">
                    <div class="cover-photo" v-if="artwork.cover_photo" :style="{ 'background-image': 'url(' + artwork.cover_photo[0].medium + ')' }">
                    </div>
                  </div>
                  <div class="artwork-info" v-if="artwork.data">
                    <h3>{{artwork.title}}</h3>
                    <p>{{artwork.data.text}}</p>
                  </div>
                </div>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </Col>
    </Row>

    <ModalHolder :title="artwork.title" m-top="0" :is-show="showArtworkModal" v-if="artwork">
      <template slot="mcontent">
        <div class="single-artwork__container">
          <div class="single-artwork__image">
            <img alt=" " :src="artwork.cover_photo[0].medium"/>
          </div>
          <div class="action-buttons" style="text-align: center; margin-top: 10px;" v-if="artwork.data.original_url">
            Original Image: <a>{{artwork.data.original_url}}</a><br/>
            <input type="text" :value="artwork.data.original_url" id="artworkUrl">
            <Button class="primary" style="margin-top: 10px" v-on:click="copyToClipboard(artwork.data.original_url)">Copy link to clipboard</Button>
          </div>
          <div class="single-artwork__info">
            <p>{{artwork.data.text}}</p>
          </div>
        </div>
      </template>
      <template slot="mfooter">
          <Button type="text" @click="showArtworkModal = false">Close</Button>
          <!-- <Button type="default" v-on:click="removeGroup" :loading="removeGroupLoader">Confirm</Button> -->
      </template>
    </ModalHolder>
  </AppLayout>
</template>

<script>
  import ArtworkSingleComponent from '@/components/ArtworkSingleComponent'
  import ModalHolder from "@/components/ModalHolderComponent";
  export default {
    name: 'EventsComponent',
    data(){
      return {
        artWorkCareplanID: Cons[0].GROUP_ID.artwork,
        showArtworkModal: false,
        activeTab: 'official'
      }
    },
    components: {
      ArtworkSingleComponent,
      ModalHolder
    },
    watch: {
      $route: function (n, o) {
        this.activeTab = this.$route.query.tab
      }
    },
    computed: {
      artworks: {
        get() {
          return this.$store.state.artwork.artworks.careplan_item;
        }
      },
      artwork: {
        get() {
          return this.$store.state.artwork.artwork;
        }
      },
      userArtworks: {
        get() {
          return this.$store.state.artwork.userArtworks.careplan_item
        }
      },
      officialArtworks: {
        get() {
          return this.$store.state.artwork.officialArtworks.careplan_item
        }
      }
    },
    methods: {
      goToArtWork(){
        this.$router.push({
          path: '/post-update/' + this.artWorkCareplanID
        })
      },
      displayArtwork(data){
        this.$store.commit('artwork/setSingleArtwork', data);
        this.showArtworkModal = true;
      },
      changeTab(data){
        this.$router.replace({ path: '?tab=' + data })
      },
      copyToClipboard(data){
        var copyText = document.getElementById("artworkUrl");
        copyText.select();
        document.execCommand("copy");
        console.log("Copied the text: " + copyText.value);
      }
    },
    mounted(){
      setTimeout(()=> {
        this.$store.dispatch('artwork/getCareplanInfo', this.artWorkCareplanID);
        this.$store.dispatch('artwork/getUserArtwork', this.artWorkCareplanID);
        this.$store.dispatch('artwork/getOfficialArtwork', this.artWorkCareplanID);
        if(this.$route.query.tab)
          this.activeTab = this.$route.query.tab
      }, 500)
    }
  }
</script>
